import { defineComponent as _defineComponent } from 'vue'
import FormLayout from '../common/FormLayout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldViewLocationNotFound',
  props: {
    isLoading: { type: Boolean }
  },
  emits: ['dismiss'],
  setup(__props: any, { emit }) {

const props = __props as {
  isLoading?: boolean
}



function handleDismiss() {
  emit('dismiss')
}

return { __sfc: true,props, emit, handleDismiss, FormLayout }
}

})